import React from "react";
import Form from "../../common_nextgen/common_components/form/Form";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import usePriceScheduleForm from "./hooks/usePriceScheduleForm"; // Adjust the import path as necessary
import { formFields } from "./PriceScheduleConfig";

const PriceScheduleForm = ({ mode }) => {
  const {
    currentMode,
    initialFormData,
    constraintErrors,
    isConfirmationModalOpen,
    keyFunc,
    keyName,
    getPageTitle,
    submitFormData,
    closeConfirmationModal,
    submitForm,
    setSelectedOption,
  } = usePriceScheduleForm(mode);

  return (
    <div className="container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitFormData}
          constraintErrors={constraintErrors}
        />
      </div>
      <div className="col col-12">
        {isConfirmationModalOpen && (
          <ConfirmationModal
            isOpen={isConfirmationModalOpen}
            onRequestClose={closeConfirmationModal}
            onBack={closeConfirmationModal}
            onSave={submitForm}
            confirmLabel="Confirm(Y/N)"
            options={[
              { label: "N-No", value: "no" },
              { label: "Y-Yes", value: "yes" },
            ]}
            setSelectedOption={setSelectedOption}
          />
        )}
      </div>
    </div>
  );
};

export default PriceScheduleForm;
